import Component from '../Component';
import $ from '../../vendor/CustomJquery';

export default class ScrollTo extends Component {

  configure() {
    return super.configure();
  }

  initialize() {
    this.subscribeToEvents();
    return super.initialize();
  }

  subscribeToEvents() {

    this.App.Events.subscribe('scroll.to.value',   this.toValue);
    this.App.Events.subscribe('scroll.to.element', this.toElement);

    $(document).on('click', '.scroll-to', () => {
      let hash = this.hash.toString().replace(/[#]/g,'');
      this.toElement('[name="'+ hash +'"]');
    });

  }

  toValue(value) {

    let scrollTo = parseInt( $(window).scrollTop() ) + value;
    $('html, body').animate({scrollTop: scrollTo}, 500, 'swing');

  }

  toElement(element) {

    let scrollTo = 0,
        target = $(element),
        navBarHeight = $('.navbar').height();

    if (target.size() > 0) {

      scrollTo = target.offset().top - navBarHeight;
      $('html,body').animate({scrollTop: scrollTo}, 500, 'swing');

    }

  }

}